import { render, staticRenderFns } from "./attr-icon.vue?vue&type=template&id=6caa4fd2&scoped=true"
import script from "./attr-icon.vue?vue&type=script&lang=js"
export * from "./attr-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caa4fd2",
  null
  
)

export default component.exports